<div class="edit-art-modal" *ngIf="slideState === 'in' || slideState === 'out'">
  <!-- Black Screen Overlay -->
  <div class="overlay" (click)="closeModal()"></div>

  <!-- Sliding Edit Form -->

  <div class="upload-form" [@slideInOut]="slideState">
    <div class="form-header flex justify-between items-center">
      <div class="edit-art-header">
        <h2>Make Payment</h2>
        <button class="close-button" (click)="closeModal()">Close ×</button>
      </div>
    </div>

    <form class="flex flex-col">
      <div class="input-details-container flex flex-col">
        <ng-content *ngFor="let art of getArts">
          <div class="first-row flex gap-3 items-start">
            <div class="flex gap-3 items-center ">
              <div class="image-preview relative">
                <app-canvas-preview style="display:block;background-color: #0000002b;border-radius: 5px;border-radius: .3em;" [drawData]="art"></app-canvas-preview>
              </div>
              <p style="text-align: left;
              max-width: 15ch;
              overflow: hidden;
              text-overflow: ellipsis;">by {{ art?.artistName }}</p>
            </div>
            <p *ngIf="!albumDetails">${{ art?.price | number:"1.2-2" }}</p>
          </div>
        </ng-content>
      </div>

      <div class="form-actions flex items-center gap-2">
        <div class="flex flex-col">
          <p class="totalPay">Total Payable</p>
          <p class="totalAmount">${{ totalPrice | number:"1.2-2" }}</p>
        </div>
        <!-- <button class="cancel pointer" type="button" (click)="closeModal()">No</button> -->
        <!-- <a class="upload pointer" [href]="paymentLink" target="_self"> Pay </a> -->
        <app-button text="Pay" (onClick)="openConfirmationPopup()"></app-button>
        <a class="upload pointer" id="myLink" [href]="paymentLink" target="_self"></a>
      </div>
    </form>
  </div>
</div>
